import type {} from "services-comun/modules/types.d.ts";

import entry from "./root/entry";

/* MÓDULOS DE ÚLTIMAS NOTICIAS*/
entry.add("noticias/ultimas");
